export const LSK_IS_LOGGED_IN = 'XpjqpRzXjh'
export const LSK_TOKEN = 'ApjqpRzXjk'
export const LSK_REFRESH_TOKEN = 'bpjqpRzXji'

export const LSK_UID = 'Kieuhdcoiuh'
export const LSK_OTP = 'KiuhuiUHUIv'
export const LSK_ASSESSMENT_DATA = 'Kivecverycg2vc'